import { computed } from 'vue';

import { useMapGetter } from 'dashboard/composables/store';

/**
 * AUTAZO INTEGRATION: the CRM provisions this exact boolean marker on the
 * current user. Truthy alternatives must never activate embedded access.
 * See docs/autazo-integration/03-frontend-conversations-only.md.
 */
export const isAutazoEmbeddedUser = user =>
  user?.custom_attributes?.autazo_embedded === true;

export const canShowConversationNavigation = () => true;

export const canShowGlobalNavigation = user => !isAutazoEmbeddedUser(user);

export const canSwitchAccounts = user => !isAutazoEmbeddedUser(user);

export const canEditContacts = user => !isAutazoEmbeddedUser(user);

export const useAutazoEmbeddedAccess = () => {
  const currentUser = useMapGetter('getCurrentUser');

  return {
    isAutazoEmbedded: computed(() => isAutazoEmbeddedUser(currentUser.value)),
    canShowConversationNavigation: computed(() =>
      canShowConversationNavigation(currentUser.value)
    ),
    canShowGlobalNavigation: computed(() =>
      canShowGlobalNavigation(currentUser.value)
    ),
    canSwitchAccounts: computed(() => canSwitchAccounts(currentUser.value)),
    canEditContacts: computed(() => canEditContacts(currentUser.value)),
  };
};
